import { render, staticRenderFns } from "./articleTreeDetail.vue?vue&type=template&id=b2d44c18&scoped=true&"
import script from "./articleTreeDetail.vue?vue&type=script&lang=js&"
export * from "./articleTreeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d44c18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2d44c18')) {
      api.createRecord('b2d44c18', component.options)
    } else {
      api.reload('b2d44c18', component.options)
    }
    module.hot.accept("./articleTreeDetail.vue?vue&type=template&id=b2d44c18&scoped=true&", function () {
      api.rerender('b2d44c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/market/articleMarket/articleTreeDetail.vue"
export default component.exports